import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.compose';
import { translate } from 'react-i18next';
import KitDetailsDrivenPlate from './components/kit-details-driven-plate';
import KitDetailsPressurePlate from './components/kit-details-pressure-plate';
import KitDetailsBearing from './components/kit-details-bearing';

function KitDetails({ product, t }) {
  return (
    <React.Fragment>
      <h3>{t('kit.composition')}</h3>
      <div className="table-wrapper">
        <div className="div-table">
          <div className="div-table-heading">
            <div className="div-table-row">
              <div className="div-table-head">{t('kit.code')}</div>
              <div className="div-table-head">{t('kit.type')}</div>
              <div className="div-table-head">{t('kit.description')}</div>
            </div>
          </div>
          <div className="div-table-body">
            {product.driven_plate && <KitDetailsDrivenPlate product={product.driven_plate} />}
            {product.pressure_plate && <KitDetailsPressurePlate product={product.pressure_plate} />}
            {product.bearing && <KitDetailsBearing product={product.bearing} />}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

KitDetails.defaultProps = {};
KitDetails.propTypes = {};
export default compose(
  translate('product'),
)(KitDetails);
